// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3FOIj","header":"MessagesList_header__1PV2f","chat":"MessagesList_chat__2Os3x"};